module.exports = __webpack_public_path__ + "img/ic_circle_green.951edf65.svg";